<template lang="pug">
.content-center.message-page
  .overlay
  .tab-nav
    ul.scrolling-wrapper
      li
        a(
          :class="selected == 'normal' ? 'active' : ''"
          @click="getNormalAnnouncement"
        ) {{ $t("ui.general") }}
      li
        a(
          :class="selected == 'special' ? 'active' : ''"
          @click="getSpecialAnnouncement"
        ) {{ $t("ui.special") }}
      li
        a(
          :class="selected == 'personal' ? 'active' : ''"
          @click="getPersonalMessage"
        ) {{ $t("ui.personal") }}
    .date-filter
      .date-input-wrapper
        input#datepicker-start.date-picker(type='text' v-model='dateFrom' placeholder='YYYY-MM-DD' autocomplete='off' readonly @change='getData')
      .text {{ $t('ui.to') }}
      .date-input-wrapper
        input#datepicker-end.date-picker(type='text' v-model='dateTo' placeholder='YYYY-MM-DD' autocomplete='off' readonly @change='getData')
    .page-group
      template(v-if="loading")
        .message
          loading
      template(v-else)
        .message(v-if="currentList.list && currentList.list.length == 0")
          .empty.text-center.mt-5
            img.no-info(src='images/empty-icon.png' alt='')
          p.no-message.text-center.mb-5 {{ $t("message.no_information_available") }}
        .message(v-else v-for="ann in currentList.list")
          p.message-text.mb-0
            span.text-break {{ ann[`msg_${$store.getters.language}`] || ann.msg_en }}
          p.message-date.mb-0.grey {{ $dayjs(ann.an_date).format("MM/DD/YYYY hh:mm A") }}
</template>

<script>
import errors from "@/errors";
import service from "@/library/_xhr-message";
import loading from "@/components/ui/loading";  

export default {
  components: {
    loading,
  },
  data() {
    return {
      loading: false,
      t: 1,
      dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split("T")[0],
      dateTo: new Date().toISOString().split("T")[0],
      suppressFocusStart: false,
      suppressFocusEnd: false,
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      naList: {},
      saList: {},
      pmList: {},
      selected: "normal",
      feedback: {
        success: false,
        status: errors.session.invalidSession
      }
    };
  },
  computed: {
    currentList() {
      if (this.selected === 'normal') return this.naList || {};
      if (this.selected === 'special') return this.saList || {};
      return this.pmList || {};
    }
  },
  watch: {
    dateFrom(val) {
      if (val >= this.dateTo) {
        this.dateFrom = this.dateTo;
      }
    },
    dateTo(val) {
      if (val <= this.dateFrom) {
        this.dateTo = this.dateFrom;
      }
    }
  },
  mounted() {
    // initialize jquery datepicker and sync with Vue model
    $('#datepicker-start').datepicker({
        format: "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        container: 'body'
    }).on('changeDate', (e) => {
        this.dateFrom = this.$dayjs(e.date).format('YYYY-MM-DD')
        this.suppressFocusStart = true
        $(e.target).datepicker('hide')
        $(e.target).blur()
        this.getData()
        this.$nextTick(() => { setTimeout(() => { this.suppressFocusStart = false }, 150) })
    })
    .on('show', (e) => {
        if (this.suppressFocusStart) {
          $(e.target).datepicker('hide')
          $(e.target).blur()
        }
    })
    .on('focus', (e) => {
        if (this.suppressFocusStart) {
          $(e.target).blur()
        }
    })
    $('#datepicker-end').datepicker({
        format: "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        container: 'body'
    }).on('changeDate', (e) => {
        this.dateTo = this.$dayjs(e.date).format('YYYY-MM-DD')
        this.suppressFocusEnd = true
        $(e.target).datepicker('hide')
        $(e.target).blur()
        this.getData()
        this.$nextTick(() => { setTimeout(() => { this.suppressFocusEnd = false }, 150) })
    })
    .on('show', (e) => {
        if (this.suppressFocusEnd) {
          $(e.target).datepicker('hide')
          $(e.target).blur()
        }
    })
    .on('focus', (e) => {
        if (this.suppressFocusEnd) {
          $(e.target).blur()
        }
    })
    // set initial input value from model
    $('#datepicker-start').datepicker('setDate', this.dateFrom)

    // Note: remove or wire #datepicker-end only if there is a corresponding input
    
    if (this.$route.query.redir === "p") {
      $("#tab-personal").click();
      this.getPersonalMessage();
    }
    this.getNormalAnnouncement();
  },
  methods: {
    getData() {
      this.fetchMessages(this.selected);
    },
    getNormalAnnouncement() {
      this.selected = "normal";
      this.fetchMessages('normal');
    },
    getSpecialAnnouncement() {
      this.selected = "special";
      this.fetchMessages('special');
    },
    getPersonalMessage() {
      this.selected = "personal";
      this.fetchMessages('personal');
    },
    fetchMessages(type) {
      const payload = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        datefrom: this.dateFrom,
        dateto: this.dateTo
      };

      this.loading = true;

      if (type === 'personal') {
        service.getPersonalMessage(payload).then(
          result => this.handleResult(result, 'pmList'),
          err => this.handleError(err)
        );
        return;
      }

      const anType = type === 'special' ? 2 : 1;
      const req = { ...payload, an_type: anType };
      service.getAnnoucement(req).then(
        result => this.handleResult(result, type === 'special' ? 'saList' : 'naList'),
        err => this.handleError(err)
      );
    },
    handleResult(result, listKey) {
      this.loading = false;
      if (result) {
        this.feedback.status = result.status;
        if (result.success == true) {
          this.$set(this[listKey], "list", result.data);
        } else {
          this.$helpers.handleFeedback(this.feedback.status);
        }
      }
    },
    handleError(err) {
      this.loading = false;
      this.feedback.success = false;
      this.feedback.status = errors.request.failed;
      this.$helpers.handleFeedback(err.status);
    }
  }
};
</script>
  